import { styled } from '@mui/material'

import { BaseContainer, BaseLayout } from '../config/styles/BaseGrid'

export const Body = styled(BaseContainer)``

export const Header = styled(BaseContainer)``

export const Root = styled(BaseLayout)``
